import {
    Box,
    Grid2 as Grid,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@mui/material";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";

interface ToolbarProps {
    dates: Date[];
    onDelete: (date: Date) => void;
}

interface ToolbarItemProps {
    date: Date;
    onDelete?: (date: Date) => void;
}
const ToolbarItem = ({ date, onDelete }: ToolbarItemProps) => {
    return (
        <ListItem sx={{ padding: 0 }}>
            <ListItemText>
                <Typography variant="caption">
                    {moment(date).format("D, MMM YYYY")}
                </Typography>
            </ListItemText>
            <ListItemIcon>
                <ListItemButton onClick={() => onDelete && onDelete(date)} sx={{ padding: { md: 0 } }} >
                    <DeleteIcon fontSize="small"></DeleteIcon>
                </ListItemButton>
            </ListItemIcon>
        </ListItem>
    );
};

const Toolbar = ({ dates, onDelete }: ToolbarProps) => {
    const { t } = useTranslation();
    return (
        <>
            <Box display="flex" justifyItems="center" sx={{ paddingTop: 2, marginRight: 4 }}>
                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: "1rem",
                        lineHeight: 1.5,
                        marginX: "auto"
                    }}
                >
                    {t("header.selectDates")}
                </Typography>
                {dates.length > 0 && (
                    <Typography
                        sx={{
                            marginLeft: 1,
                            fontWeight: 600,
                            fontSize: "1rem",
                            lineHeight: 1.5,
                        }}
                    >
                        ({dates.length})
                    </Typography>
                )}
            </Box>
            <Box
                sx={{
                    height: "85%",
                    overflowY: "scroll",
                    padding: 2,
                }}
            >
                <Grid container spacing={2}>
                    {dates
                        .sort((a, b) =>
                            moment(a, "YYYY-MM-DD").diff(
                                moment(b, "YYYY-MM-DD")
                            )
                        )
                        .map((date) => (
                            <Grid size={{ xs: 6 }} key={date.toString()}>
                                <ToolbarItem
                                    date={date}
                                    onDelete={() => onDelete(date)}
                                />
                            </Grid>
                        ))}
                </Grid>
            </Box>
        </>
    );
};

export default Toolbar;
